import { render, staticRenderFns } from "./messageInput.vue?vue&type=template&id=55690c83"
import script from "./messageInput.vue?vue&type=script&lang=js"
export * from "./messageInput.vue?vue&type=script&lang=js"
import style0 from "./messageInput.vue?vue&type=style&index=0&id=55690c83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports